<template>
  <div class="system-params-edit">
    <el-form class="form" :model="formData" :rules="rules" label-position="top" ref="formRef" inline>
      <el-form-item label="展示名称" prop="displayName" class="w-p-50-d-10">
        <el-input v-model="formData.displayName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="参数名称" prop="name" class="w-p-50-d-10">
        <el-input v-model="formData.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="参数类型" prop="style" class="w-p-50-d-10">
        <el-select class="w-p-100" v-model="formData.style" :clearable="false">
          <el-option v-for="item in styleList" :key="item.value" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="参数值" prop="value" class="w-p-50-d-10">
        <el-input v-model="formData.value" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="参数说明" prop="description" class="w-p-100">
        <el-input v-model="formData.description" placeholder="请输入"></el-input>
      </el-form-item>
      <div class="bottom-btn">
        <el-button class="submit-btn" v-loading="btnLoading" @click="handleConfirm">确定</el-button>
        <el-button class="cancel-btn" @click="handleClose">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    editModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      btnLoading: false,

      styleList: [
        { label: '文本输入框', value: 1 },
        { label: '数字输入框', value: 2 },
        { label: '两值单选', value: 3 },
        { label: '上传文件', value: 4 },
        { label: '浮点数', value: 5 },
      ],
      formData: {
        displayName: '',
        name: '',
        style: 1,
        value: '',
        description: ''
      },
      rules: {
        displayName: [
          { required: true, message: '请输入展示名称', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入参数名称', trigger: 'blur' },
        ],
        style: [
          { required: true, message: '请选择参数类型', trigger: 'change' },
        ],
        value: [
          { required: true, message: '请输入参数值', trigger: 'blur' },
        ],
      }
    }
  },
  watch: {
    editModal(val) {
      if (val) {
        for (let key in this.formData) {
          this.formData[key] = ''
        }
        this.formData.style = 1
      }
    }
  },
  methods: {
    ...mapActions(['fetchData']),
    handleClose() {
      this.$emit('close')
    },
    // 处理确认
    handleConfirm() {
      this.$refs.formRef.validate(pass => {
        if (pass) {
          this.reqSave()
        } else {
          this.$message.warning('请按要求填写参数')
        }
      })
    },
    // 保存
    reqSave() {
      let url = "SYSTEM.PARAM.POST_SAVE_OR_UPDATE";
      let params = JSON.parse(JSON.stringify(this.formData))
      params.isShow = 1 // 默认

      this.btnLoading = true
      this.fetchData({ url, method: "post", params, headers: { 'Content-Type': 'application/json' }, flag: true })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("添加成功！");
            this.$emit('success')
          } else {
            this.$message.error(res.msg || '添加失败！')
          }
        })
        .catch((err) => {
          this.$message.success(err);
        }).finally(() => {
          this.btnLoading = false
        });
    }
  }
}
</script>

<style lang="less" scoped>
.form {
  justify-content: space-between;
  width: 100%;
  :deep(.el-form-item) {
    margin-right: 15px;
  }
  .bottom-btn {
    margin-top: 20px;
    text-align: center;
    width: 100%;
  }
}
.w-p-50-d-10 {
  width: calc(~"50% - 15px");
}
</style>